<template>
  <sf-modal
    v-if="modalOpen"
    content-class-name="sf-pad-3"
    size="m"
    @close="close"
  >
    <template #title>{{
      I18n.t('reports.subnav.analytical_dimensions')
    }}</template>

    <template #body>
      <div class="sf-grid sf-grid-fluid">
        <div class="sf-row">
          <div
            v-for="(dimensionType, index) in formattedDimensions"
            :key="`${dimensionType.number}-${index}`"
            class="sf-col"
          >
            <div class="sf-title sf-pad-l-3 sf-below-2">
              {{
                I18n.t('ledger_import.columns.analytical_dimension_x', {
                  dimension: dimensionType.number + 1,
                })
              }}
            </div>
            <div
              class="sf-tab sf-overflow-scroll"
              style="max-height: calc(100vh - 500px)"
            >
              <div
                v-for="dimension in dimensionType.dimensions"
                :key="dimension.id"
                class="sf-tab-item"
              >
                <sf-checkbox
                  v-model="dimension.checked"
                  :label="dimension.reference"
                ></sf-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <a v-if="editDimensionsUrl" :href="editDimensionsUrl" class="sf-btn">{{
        I18n.t('dimension.edit')
      }}</a>
      <a class="sf-btn" @click="close">{{ I18n.t('reports.subnav.cancel') }}</a>
      <a class="sf-btn sf-btn-primary" @click="apply">{{
        I18n.t('reports.subnav.apply')
      }}</a>
    </template>
  </sf-modal>
</template>

<script>
import { SfModal } from '@app/shared/vue/components/sf-modal'

import { setQueryParams } from '../../../utils/url-helpers'
import SfCheckbox from '@app/shared/vue/components/sf-checkbox'

export default {
  components: {
    SfModal,
    SfCheckbox,
  },

  data() {
    return {
      modalOpen: false,
      formattedDimensions: [],
    }
  },

  methods: {
    openModal(context) {
      this.formattedDimensions = context.formattedDimensions
      this.editDimensionsUrl = context.editDimensionsUrl
      this.modalOpen = true
    },

    close() {
      this.modalOpen = false
    },

    apply() {
      const selectedDimenionsList = {}
      this.formattedDimensions.forEach((dimensionType) => {
        dimensionType.dimensions.forEach((dimension) => {
          selectedDimenionsList[`selected_dimensions[${dimension.id}]`] =
            dimension.checked ? 1 : undefined
        })
      })

      setQueryParams(selectedDimenionsList)
      Turbolinks.visit(window.location.href)
    },
  },
}
</script>
